import { useTranslation } from 'react-i18next';
import { Button } from '@anytag/shared-atoms';
import { useToggleState } from '@anytag/shared-hooks';
import { CustomShopeeCampaignsModal } from './custom-shopee-campaigns-modal';

export const CustomShopeeCampaignsTrigger = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { status, toggleStatus } = useToggleState();

  return (
    <>
      <Button variant="solid" title={t('Button.Pull more campaigns')} onClick={toggleStatus} className={className} />
      <CustomShopeeCampaignsModal open={status} onClose={toggleStatus} />
    </>
  );
};
